import styled from 'styled-components';

import { breakPoint, COLORS, FONTS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Input from '@r1-frontend/ui-react/components/input';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';

export const Text = styled.div`
    ${FONTS.S};
`;

export const EmailPopup = styled(DefaultPopup)`
    min-height: 324px !important;
    width: 1013px !important;
    @media(${breakPoint(1024)}) {
        width: 800px !important;
    }
    @media(${breakPoint(768)}) {
        margin-left: 130px !important;
        width: auto !important;
    }
    @media(${breakPoint(320)}) {
        margin-left: 5px !important;
    }
`;

export const Header = styled.div`
    ${FONTS.H2};
    margin: 56px 20px 10px 60px;
    @media(${breakPoint(768)}) {
        margin-top: 20px;
        ${FONTS.S};
    }
    @media(${breakPoint(320)}) {
        text-align: center;
        margin-left: 10px;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 60px;
    @media(${breakPoint(320)}) {
        margin-left: 10px;
        justify-content: center;
        text-align: center;
    }
`;

export const EmailBlock = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px 6px 0 0;
  width: 454px;
`;

export const EmailInput = styled(Input)`
    margin-bottom: 5px;
`;

export const EmailNotice = styled.div`
  margin: 5px 0;
  ${FONTS.XXS};
  color: ${COLORS.middleGray};
`;

export const CodeBlock = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px 6px 0 6px;
  width: 200px;
  @media (${breakPoint(1024)}) {
    margin: 20px 20px 20px 0;
  }
  @media (${breakPoint(320)}) {
    align-items: center;
    margin-left: 20px;
  }
`;

export const CodeInput = styled(Input)`
    margin-bottom: 5px;
`;

export const ErrorMessage = styled.div`
  margin: 5px 0;
  ${FONTS.XXS};
  color: ${COLORS.red};
`;

export const SendAgainLink = styled.a`
  max-width: 200px;
  margin: 5px 0;
  ${FONTS.XXS};
  border-bottom: 1px dotted;
  cursor: pointer;
`;

export const Button = styled(BaseButton)`
  height: 48px;
  padding: 9px 24px;
  max-width: 172px;
  margin: 20px 6px 0 6px;
  @media (${breakPoint(1024)}) {
    margin: 20px 0 20px 0;
  }
`;
